<template>
  <div>
<!--    <template v-if="this.isMap">-->
      <Popup :isButtons="isButtons" :photo="imgdata" :creators="creators" :index="index"  :isSelecteAble="isSelecteAble" @setSliderImages="setSliderImages"></Popup>

      <input type="checkbox"
             class="d-none"
             v-model="detailsSelectedImages"
             :id="'image'+imgdata.pdphotoid"
             :value="imgdata"
             :ref="imgdata.pdphotoid"
             :disabled="!isSelecteAble"/>

      <label :for="'image'+imgdata.pdphotoid" v-on:touchstart="onTouchStart(imgdata)">
        <div data-aspect-ratio="4:3" v-bind:class="{ 'photohover': imgdata.hover }" :id="'photoframe_' + imgdata.pdphotoid" style="">
<!--          :style="{ 'backgroundImage': 'url(' + imgdata.src + ')' }"-->
          <div class=""
               style=""
               :style="{ 'backgroundImage': 'url(' + getImagePath(imgdata) + ')' }"
               :class="{'draggableimage': this.isMap==true}"
               :alt="imgdata.origname"
               :data-value="imgdata.pdphotoid"
               :data-index="index"
               :data-photoid="imgdata.pdphotoid"
               :data-runid="imgdata.runid"
               :photo_id='imgdata.id'
               @dblclick="showModal(imgdata)"
               ref="img"
               :draggable="(isEdit.toString() == 'true' && isMap)"
               v-on:dragstart="setDropPhotoId(imgdata,$event)"
               v-on:mouseover="imagehover(imgdata, $event)"
               v-on:mouseout="imageHoverStop(imgdata, $event)"
          >
          </div>
        </div>
      </label>
<!--    </template>-->


    <div class="has-gps" v-if="isEdit && imgdata.exifhasgps && isMap" @click="allocateByGPS(imgdata, $event)" @mouseover="allocatePreviewByGPS(imgdata, $event)" @mouseout="removePreviewByGPS()"><img src="@/assets/images/has-gps.png" /></div>
    <div class="has-gps" v-if="isEdit && imgdata.exifhasgps && !isMap"><img src="@/assets/images/has-gps.png" /></div>
    <div class="has-planlocation" v-if="isEdit && imgdata.inplan"><img src="@/assets/images/has-planlocation.png" /></div>
    <div class="has-tags" v-if="isEdit && imgdata.params.length"><img src="@/assets/images/has-tags.png" /></div>
    <div class="has-description" v-if="isEdit && imgdata.description"><img src="@/assets/images/has-description.png" /></div>
    <div class="has-memos" v-if="isEdit && imgdata.memos.length"><img src="@/assets/images/has-memos.png" /></div>

    <div class="simple-photo-option">
      <ul :data-dtype="this.dtype()">
        <li>Nr.{{imgdata.runid}}</li>
        <li>|</li>
        <li>{{moment(imgdata.photodate).format('DD.MM.YYYY')}}</li>
        <li>|</li>
        <li>{{moment(imgdata.photodate).format('HH:mm')}} Uhr</li>
      </ul>
    </div>
  </div>

</template>

<script>

import Popup from '../infoPopup'
import process from 'shelljs'

export default {
  name: 'photodetail',
  data () {
    return {
      lastTapTime: 0,
      tapCount: 0
    }
  },
  components: {
    Popup
  },
  methods: {
    setSliderImages() {
      let _this = this
      return

      // this.$store.state.photo.tempPhotoEdit = {
      //   img: this.imgdata,
      //   index: this.index,
      //   event: event
      // }
      // console.log('emited b', this.imgdata, this.index, event, this.$store.state.photo.isDetailView, this.photo_id, this.$store.state.photo.tempPhotoEdit)
      // if(!this.$store.state.photo.isDetailView) {
      //   this.$store.commit('setDetailsView')
      // }


      // _this.$emit('enableEditmode')
      //_this.$emit('setSliderImages', this.imgdata, this.index, event, 'setedit')
      console.log('isEdit - EMMITTER')


      // this.isEdit = true;
    },
    getImagePath(photo) {
      const projectid = this.$route.params.id
      const jwt = localStorage.getItem('jwt');
      console.log('getImagePath', projectid, photo.pdphotoid, jwt);
      return `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${projectid}&id=${photo.pdphotoid}&token=${jwt}`
    },

    dtype() {
      if(this.isMap) {
        if(this.isEdit) return 'PD MAP EDIT'
        return 'PD MAP'
      } else {
        return 'PD'
      }
    },
    allocateByGPS(imgdata, $event) {
      if(this.isMap) {
        this.$parent.allocateByGPS(imgdata, $event)
      }
    },
    allocatePreviewByGPS(imgdata, $event) {
      console.log('allocatePreviewByGPS CHILD')
      if(this.isMap) {
        console.log('allocatePreviewByGPS PARENT')
        this.$parent.allocatePreviewByGPS(imgdata, $event)
      }
    },
    removePreviewByGPS() {
      if(this.isMap) {
        this.$parent.removePreviewByGPS()
      }
    },
    setDropPhotoId(photo,$event) {
      if(this.isMap) {
        console.log('setDropPhotoId Child')
        this.$parent.setDropPhotoId(photo,$event)
      }
    },
    imagehover(photo, $event) {
      if(this.isMap) {
        console.log('imagehover Child')
        this.$parent.imagehover(photo, $event)
      }
    },
    imageHoverStop(photo, $event) {
      if(this.isMap) {
        console.log('imageHoverStop Child')
        this.$parent.imageHoverStop(photo, $event)
      }
    },
    showModal(imgdata) {
      console.log('ShowModal Child', this.$parent )

      this.$parent.$parent.loadXXL(imgdata)
      //this.$parent.showModal(imgdata,this.$parent.photos)
    },
    onTouchStart(img) {
      const currentTime = new Date().getTime();
      if (this.tapCount === 0) {
        this.tapCount = 1;
        this.lastTapTime = currentTime;
      } else if (this.tapCount === 1) {
        if (currentTime - this.lastTapTime < 500) {
          this.tapCount = 0;
          this.showModal(img)
        } else {
          this.tapCount = 1;
          this.lastTapTime = currentTime;
        }
      }
    }
  },
  computed: {

    isSelecteAble: {
      get () {
        return this.$store.state.photo.isBottomNav
      }
    },
    selectedImages: {
      get () {
        if (this.isSelecteAble) {
          return this.$store.state.photo.selectedPhotos
        } else {
          return this.$store.state.photo.detailsSelectedImages
        }
      },
      set (val) {
        if (this.isSelecteAble) {
          this.$store.commit('setSelectedPhotos', val)
        } else {
          this.$store.commit('setDetailsSelectedImages', val)
        }
      }
    },
    detailsSelectedImages: {
      get () {
        if (this.isSelecteAble) {
          return this.$store.state.photo.selectedPhotos
        } else {
          return this.$store.state.photo.detailsSelectedImages
        }
      },
      set (val) {
        if (this.isSelecteAble) {
          this.$store.commit('setSelectedPhotos', val)
        } else {
          this.$store.commit('setDetailsSelectedImages', val)
        }
      }
    },
    creators () {
      return this.$store.state.creators
    },

  },
  props: {
    imgdata: {
      type: Object,
      default() {
        return {
          runid: 0,
          photodateBydot: 0,
          photodateBytime: 0
        }
      }
    },
    isButtons: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isMap: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    photo_id: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photo/components/subitems/photodetail.vue